
import { cn } from "@/lib/utils";

interface NotificationBadgeProps {
  count: number;
  className?: string;
  max?: number;
  variant?: "default" | "outline";
}

export function NotificationBadge({
  count,
  className,
  max = 99,
  variant = "default",
}: NotificationBadgeProps) {
  if (count <= 0) return null;
  
  const displayCount = count > max ? `${max}+` : count;
  
  return (
    <div
      className={cn(
        "inline-flex items-center justify-center rounded-full text-xs font-bold",
        variant === "default" 
          ? "bg-destructive text-destructive-foreground h-5 min-w-5 px-1" 
          : "border border-destructive text-destructive h-4 min-w-4 px-0.5",
        className
      )}
    >
      {displayCount}
    </div>
  );
}
